/**
 * Formatadores compartilhados para métricas e custos.
 *
 * Convenções (locale pt-BR em tudo):
 * - Moeda USD: >= US$ 0,01 → 2 casas decimais; valores menores (mas > 0) → 4 casas.
 * - Tokens: notação compacta ("1,5 mi", "12,3 mil").
 * - Percentual: 1 casa decimal.
 */

const usd2 = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const usd4 = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

const compact = new Intl.NumberFormat('pt-BR', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

const integer = new Intl.NumberFormat('pt-BR');

const pct1 = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 1,
});

/** Formata valores em USD: 2 casas para >= $0.01, 4 casas para valores menores. */
export function formatUsd(value: number | null | undefined): string {
  const n = Number(value || 0);
  if (n === 0) return usd2.format(0);
  return Math.abs(n) >= 0.01 ? usd2.format(n) : usd4.format(n);
}

/** Formata contagem de tokens em notação compacta (1,5 mi / 12,3 mil). */
export function formatTokens(value: number | null | undefined): string {
  const n = Number(value || 0);
  return n >= 1_000 ? compact.format(n) : integer.format(n);
}

/** Formata inteiro com separador de milhar pt-BR. */
export function formatInteger(value: number | null | undefined): string {
  return integer.format(Number(value || 0));
}

/** Formata percentual com no máximo 1 casa decimal ("87,5%"). */
export function formatPct(value: number | null | undefined): string {
  return `${pct1.format(Number(value || 0))}%`;
}

/** Formata data ISO (YYYY-MM-DD) como dd/mm. */
export function formatDayMonth(isoDate: string): string {
  return new Date(isoDate + 'T12:00:00').toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
  });
}

/** Formata data ISO (YYYY-MM-DD) como dd/mm/aaaa. */
export function formatDate(isoDate: string): string {
  return new Date(isoDate + 'T12:00:00').toLocaleDateString('pt-BR');
}
